/**
 * Id del área scrollable principal del shell privado v3 (coincide con `<main id="…">` en `PrivateLayout` del ui-kit).
 * Para usar como `scrollableTarget` en listados con scroll infinito bajo ese layout.
 */
const V3_SCROLL_ROOT_ID = "app";

export default V3_SCROLL_ROOT_ID;
